import Icons from '@/constants/Icons';
import RouteNames from '@/constants/RouteNames';
import { t } from '@/i18n';
import AppAction from '@/models/core/AppAction';
import type { MovementType } from '@/types/movement';
import MovementDeleteModal from '@/views/movement/MovementDeleteModal.vue';
import { useModal } from 'vue-final-modal';

type MovementActionParams = {
  movementId: string;
  movementUid: string;
  movementType: MovementType;
};

export const movementEditAction = (params: Partial<MovementActionParams>) =>
  new AppAction({
    icon: Icons.Core.Edit,
    name: RouteNames.Movement.Edit,
    route: { name: RouteNames.Movement.Edit, params },
  });

export const movementDeleteAction = (params: Partial<MovementActionParams>) =>
  new AppAction({
    handler: () => {
      const { open } = useModal({ attrs: params as typeof MovementDeleteModal.props, component: MovementDeleteModal });
      open();
    },
    icon: Icons.Core.Delete,
    name: 'MovementDelete',
  });

export const movementCreateAction = (params: Partial<MovementActionParams>) =>
  new AppAction({
    icon: Icons.Core.Create,
    label: t('movements.types.' + params.movementType),
    name: RouteNames.Movement.Create + params.movementType,
    route: { name: RouteNames.Movement.Create, params },
  });

export const movementListAction = () =>
  new AppAction({
    icon: Icons.Movement,
    name: RouteNames.Movement.List,
    route: { name: RouteNames.Movement.List },
  });
